var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckInDeclined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 87,
    viewBox: "0 0 99 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8895 7.28479L4.19285 70.2163C3.41563 71.5623 3.00439 73.0883 3.00003 74.6426C2.99568 76.1968 3.39837 77.7251 4.16804 79.0754C4.93771 80.4257 6.04753 81.5509 7.38708 82.3391C8.72663 83.1273 10.2492 83.5511 11.8034 83.5682H87.1966C88.7508 83.5511 90.2734 83.1273 91.6129 82.3391C92.9525 81.5509 94.0623 80.4257 94.832 79.0754C95.6016 77.7251 96.0043 76.1968 96 74.6426C95.9956 73.0883 95.5844 71.5623 94.8072 70.2163L57.1105 7.28479C56.3171 5.97679 55.2 4.89535 53.8669 4.14482C52.5338 3.39429 51.0298 3 49.5 3C47.9702 3 46.4662 3.39429 45.1331 4.14482C43.8 4.89535 42.6829 5.97679 41.8895 7.28479V7.28479Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5011 30.1611V47.9636",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5011 65.7656H49.5461",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInDeclined);
export default __webpack_public_path__ + "static/media/checkIn-declined.d9ace0d5a7e218e5353241547b086b31.svg";
export { ForwardRef as ReactComponent };